import React, {useCallback, useEffect, useRef, useState} from "react";
import {AutoComplete} from "primereact/autocomplete";
import RemotingService from "../../../services/remoting-service/RemotingService";

const FacilitySelector = ({value, onValueChange, onFacilitySelect, inputStyle}) => {
    const [suggestions, setSuggestions] = useState([]);
    const [inputValue, setInputValue] = useState(value || "");
    const debounceRef = useRef();
    const autoCompleteRef = useRef(null);

    const fetchFacilities = useCallback((searchText) => {
        RemotingService.getRemoteCall(
            'api/appointment/referring-facilities',
            {searchText},
            (facilities) => setSuggestions(facilities || []),
            undefined,
            false,
            false
        );
    }, []);

    const searchFacilities = useCallback((event) => {
        const query = event.query || '';
        if (debounceRef.current) {
            clearTimeout(debounceRef.current);
        }
        debounceRef.current = setTimeout(() => fetchFacilities(query), 200);
    }, [fetchFacilities]);

    useEffect(() => {
        fetchFacilities('');
    }, [fetchFacilities]);

    useEffect(() => {
        setInputValue(value || "");
    }, [value]);

    return (
        <AutoComplete
            ref={autoCompleteRef}
            value={inputValue}
            suggestions={suggestions}
            completeMethod={searchFacilities}
            field="name"
            placeholder="Search referring clinic..."
            minLength={0}
            inputStyle={inputStyle || {width: "95%", padding: "5px 11px"}}
            inputClassName="AddModalAutoComplete"
            onFocus={() => {
                fetchFacilities('');
                if (autoCompleteRef.current?.search) {
                    autoCompleteRef.current.search({}, '', 'focus');
                }
            }}
            onChange={(e) => {
                setInputValue(e.value);
                if (onValueChange) {
                    onValueChange(e.value);
                }
            }}
            onSelect={(e) => {
                const selectedName = e.value?.name || "";
                setInputValue(selectedName);
                if (onValueChange) {
                    onValueChange(selectedName);
                }
                if (onFacilitySelect) {
                    onFacilitySelect(e.value);
                }
            }}
            itemTemplate={(facility) => (
                <div>
                    <div><strong>{facility.name}</strong></div>
                    <div style={{fontSize: '0.85em', color: '#666'}}>
                        ID: {facility.eclaimId}
                    </div>
                </div>
            )}
        />
    );
};

export default FacilitySelector;
